export const cofaceContractStates = {
  active: 'ACTIVE',
};
